module.exports = __webpack_public_path__ + "static/media/5041.f4d482ba.jpg";